import { ReactElement, ReactNode } from 'react';
import { useTheme } from '../context';

export interface BoxProps {
  icon?: ReactElement;
  header?: string | ReactNode;
  headerHTML?: string;
  subHeader?: string | ReactNode;
  subHeaderHTML?: string;
  children?: ReactNode;
  action?: ReactElement;
  subAction?: ReactNode;
  className?: string;
}

export const Box = ({
  className,
  icon,
  header,
  headerHTML,
  subHeader,
  subHeaderHTML,
  children,
  action,
  subAction,
}: BoxProps) => {
  const { isWebView } = useTheme();
  return (
    <>
      <section className={`box${className ? ` ${className}` : ''} ${isWebView ? 'box--webview' : ''}`}>
        {!!icon && (
          <div
            className={'box__icon'}
            aria-hidden="true"
          >
            {icon}
          </div>
        )}
        {!!header && <h1 className={'box__header'}>{header}</h1>}
        {!!headerHTML && (
          <div
            className={'box__header'}
            dangerouslySetInnerHTML={{ __html: headerHTML }}
          />
        )}
        {!!subHeader && <div className={'box__sub-header'}>{subHeader}</div>}
        {!!subHeaderHTML && (
          <div
            className={'box__sub-header'}
            dangerouslySetInnerHTML={{ __html: subHeaderHTML }}
          />
        )}
        {!!children && <section className={'box__body'}>{children}</section>}
        {!!action && <div className={`box__action${isWebView ? ' box__action--webview' : ''}`}>{action}</div>}
        {!!subAction && <div className={'box__sub-action'}>{subAction}</div>}
      </section>
    </>
  );
};
